import React, { useState } from 'react';
import { useLang } from '../../contexts/LangContext';
import { generateParkingLegacyApiKey } from '../../utils/parkingLegacyApiKey';
import { fieldInputClass } from '../../utils/buildingForm';

type Props = {
  value: string;
  onChange: (value: string) => void;
  hasError?: boolean;
  errorMessage?: string;
};

export const ParkingLegacyApiKeyField: React.FC<Props> = ({
  value,
  onChange,
  hasError,
  errorMessage,
}) => {
  const { t } = useLang();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!value.trim()) return;
    try {
      await navigator.clipboard.writeText(value.trim());
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // ignore
    }
  };

  return (
    <div className="pt-4 border-t border-gray-200">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {t('parkingLegacyApiKey')}
      </label>
      <p className="mb-3 text-xs text-gray-500">{t('parkingLegacyApiKeyHint')}</p>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-start">
        <input
          type="text"
          name="parkingLegacyApiKey"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={t('parkingLegacyApiKeyPlaceholder')}
          className={`${fieldInputClass(!!hasError)} font-mono text-sm flex-1`}
          maxLength={64}
          autoComplete="off"
          spellCheck={false}
        />
        <div className="flex flex-wrap gap-2 shrink-0">
          <button
            type="button"
            onClick={() => onChange(generateParkingLegacyApiKey())}
            className="px-3 py-2 text-sm font-medium text-cyan-700 bg-cyan-50 border border-cyan-200 rounded-lg hover:bg-cyan-100"
          >
            {t('generateParkingLegacyApiKey')}
          </button>
          {value.trim() && (
            <>
              <button
                type="button"
                onClick={handleCopy}
                className="px-3 py-2 text-sm font-medium text-gray-700 bg-gray-50 border border-gray-200 rounded-lg hover:bg-gray-100"
              >
                {copied ? t('copied') : t('copy')}
              </button>
              <button
                type="button"
                onClick={() => onChange('')}
                className="px-3 py-2 text-sm font-medium text-red-700 bg-red-50 border border-red-200 rounded-lg hover:bg-red-100"
              >
                {t('revokeParkingLegacyApiKey')}
              </button>
            </>
          )}
        </div>
      </div>
      {errorMessage && (
        <p className="mt-1 text-sm text-red-600">{errorMessage}</p>
      )}
    </div>
  );
};
